import { useQuery } from "@apollo/client";
import { GOOGLE_OAUTH_QUERY } from "apollo";
import { Text, GoogleSignInBtn, PageLayout, Separator } from "components";
import { MultiplayerLogo, StarIcon } from "components/icons";
import React, { useCallback, useEffect } from "react";
import { getAccessToken, removeTokens } from "services";
import { GoogleOauthQueryDto } from "types";
import { E_Route } from "utils/constants";
import { extractFromQuery } from "utils/helpers";
import ReactGA from "react-ga4";
import { List, ListItem, LoginContainer, LogoStyle } from "./styles";

export const LoginScreen: React.FC = () => {
  const { data } = useQuery<any, GoogleOauthQueryDto>(GOOGLE_OAUTH_QUERY, {
    variables: {
      oauthData: {
        redirect: `${process.env.REACT_APP_HOST_URL}${E_Route.AuthContinue}`,
        type: "login",
        scopes: [
          "https://www.googleapis.com/auth/userinfo.email",
          "https://www.googleapis.com/auth/userinfo.profile",
          "https://www.googleapis.com/auth/gmail.modify",
          //"https://www.googleapis.com/auth/calendar.readonly",
          //"https://www.googleapis.com/auth/calendar.events",
          "https://www.googleapis.com/auth/contacts.readonly",
          "https://www.googleapis.com/auth/contacts.other.readonly",
        ],
      },
    },
  });

  const checkAuth = (authWindow: Window | null) => {
    //const openGmail = () => {
    //  window.open("https://mail.google.com/mail/u/0/#inbox", "_blank");
    //};
    const intervalId = setInterval(() => {
      const token = getAccessToken();
      if (token) {
        clearInterval(intervalId);
        if (authWindow) {
          //authWindow.close();
        }
        //openGmail();
        const redirect = localStorage.getItem("redirect");
        if (redirect) {
          window.location.href = redirect;
          localStorage.removeItem("redirect");
        } else {
          window.location.href = E_Route.Home;
        }
        window.close();
      }
    }, 1000);
  };

  const handleGoogleLogin = useCallback(() => {
    ReactGA.event({
      category: "Login",
      action: `Login clicked`,
      label: "Login",
      nonInteraction: false,
      transport: "xhr",
    });
    if (data?.googleOAuthUrl) {
      removeTokens();
      const url = data?.googleOAuthUrl;
      const authWindow = window.open(url, "_blank");
      checkAuth(authWindow);
    }
  }, [data?.googleOAuthUrl]);

  useEffect(() => {
    const { source } = extractFromQuery<any>(window.location.search);
    if (source && source === "ads") {
      handleGoogleLogin();
    }
  }, [handleGoogleLogin]);

  return (
    <PageLayout title="Login | Multiplayer">
      <LoginContainer>
        <div>
          <Separator.Horizontal spacing={8} />
          <MultiplayerLogo style={LogoStyle} />
        </div>
        <Text.H1>Meet Multiplayer.</Text.H1>
        <Text.H4 color="seconday">An AI executive assistant that:</Text.H4>

        <List>
          <ListItem>
            <StarIcon
              fill="highlight/3"
              style={{ width: "21px", height: "20px" }}
            />
            Pre-reads and triages your inbox for you{" "}
          </ListItem>
          <ListItem>
            <StarIcon fill="highlight/3" />
            Briefs you on your day
          </ListItem>
          <ListItem>
            <StarIcon fill="highlight/3" />
            Prepares you for your meetings
          </ListItem>
          <ListItem>
            <StarIcon fill="highlight/3" />
            Writes email drafts on your behalf
          </ListItem>
          <ListItem>
            <StarIcon fill="highlight/3" />
            Does not train off your data or allows others to
          </ListItem>
        </List>

        <div style={{}}>
          <Text.Body color="seconday" style={{ textAlign: "center" }}>
            Start your 30 day free trial. No credit card required.
          </Text.Body>
          <Separator.Horizontal spacing={1} />
          <GoogleSignInBtn onClick={handleGoogleLogin} />
        </div>
        <Separator.Horizontal spacing={3} />
        <Text.BodyXS color="seconday" style={{ textAlign: "center" }}>
          Want a personalized onboarding?{" "}
          <Text.Link
            size="body-xs"
            target="_blank"
            rel="noreferrer"
            href="https://calendar.app.google/fKShuMCge7R8FbHh9"
          >
            Click here
          </Text.Link>
        </Text.BodyXS>

        <Separator.Horizontal spacing={8} />
        <Text.BodyXS>
          By proceeding, you agree to the 
          <Text.Link
            size="body-xs"
            target="_blank"
            rel="noreferrer"
            href="https://www.multiplayer.work/terms-of-service"
          >
            Terms of service
          </Text.Link>
           and {" "}
          <Text.Link
            size="body-xs"
            target="_blank"
            rel="noreferrer"
            href="https://www.multiplayer.work/privacy-policy"
          >
            Privacy policy
          </Text.Link>
        </Text.BodyXS>
      </LoginContainer>
    </PageLayout>
  );
};
